import * as fabric from 'office-ui-fabric-react';
import { IDropdownOption } from 'office-ui-fabric-react';
import { useEffect, useState } from 'react';
import { IServiceStatistic } from '../../model';

const initialTicketFilterOptions: IDropdownOption[] = [
    {
        selected: true,
        key: '-1',
        text: 'Visi bilietai'
    },
    {
        selected: false,
        key: '0',
        text: 'Vizitai'
    }
];

const useLocationServices = (services: IServiceStatistic[], existingFilterOptions: fabric.IDropdownOption[]) => {
    const [ticketFilterOptions, setTicketFilterOptions] = useState<fabric.IDropdownOption[]>([]);

    useEffect(() => {
        if (services.length > 0) {
            let options: IDropdownOption[] = [];
            options = initialTicketFilterOptions.map((x) => x);

            services.map((x) => {
                options.push({
                    selected: false,
                    key: x.id,
                    text: x.name ?? ''
                });
            });

            options.map((x) => {
                x.selected = existingFilterOptions.find(e => e.key === x.key)?.selected || false;
            });

            setTicketFilterOptions(options);
        } else {
            let options: IDropdownOption[] = [];
            options = initialTicketFilterOptions.map((x) => x);
            setTicketFilterOptions(options);
        }
    }, [services]);

    return ticketFilterOptions;
};

export default useLocationServices;
